import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderInfo } from '../../models/order-info';
import { environment } from '../../../../../environments/environment';
import { LocalizationService } from '../../../../services/localization.service';
import { faSearch, faTicketAlt, faGift } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-order-info-list',
  templateUrl: './order-info-list.component.html',
  styleUrls: ['./order-info-list.component.css']
})
export class OrderInfoListComponent implements OnInit {

  public faSearch: IconDefinition = faSearch;
  public faTicketAlt: IconDefinition = faTicketAlt;
  public faGift: IconDefinition = faGift;

  @Input()
  orders: OrderInfo[];

  constructor(
    private localizationService: LocalizationService,
  ) { }

  @Output()
  orderClick: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  paymentClick: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  cancelClick: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit(): void {
  }

  formatDate(date: Date): string {
    return this.localizationService.formatDate(date);
  }


  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  onOrderClick(orderInfo: OrderInfo): void {
    if (!orderInfo) {
      return;
    }

    if (orderInfo.state !== 'cancel') {
      this.orderClick.emit(orderInfo.orderId);
    }
  }

  onPaymentClick(orderInfo: OrderInfo): void {
    if (!orderInfo) {
      return;
    }

    if (orderInfo.state === 'draft') {
      this.paymentClick.emit(orderInfo.orderId);
    }
  }

  onCancelClick(orderInfo: OrderInfo): void {
    if (!orderInfo) {
      return;
    }

    if (orderInfo.state === 'draft') {
      this.cancelClick.emit(orderInfo.orderId);
    }
  }
}
